import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './pages/home/Home';
import Careers from './pages/careers/Careers';
import Components from './pages/Components';
import Navbar from './components/Navbar';
import { Box, createTheme, CssBaseline, ThemeProvider } from '@mui/material';
// import {config} from './config';
import Footer from './components/Footer';

const theme = createTheme({
  palette: {
    primary: {
      main: "#aa1155", 
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#1155aa",
    },
  },
  typography: {
    // fontFamily: "'Roboto Serif', serif",
  },
  components: {
    MuiLink: {
      styleOverrides: {
        root: {
          color: "primary.main", 
          textDecoration: "none", 
          "&:hover": {
            textDecoration: "underline", 
          },
        },
      },
    },
  },
});

// const navBarHeight = config.navbarHeight

export default function App() {
  return (
    <ThemeProvider theme={theme}>

      <CssBaseline />
        <Router>
          <Navbar />
          <Box
            sx={{
              
            }}
          >
            <Routes>
              <Route path="/services/surveillance" exact element={<Home />} />
              <Route path="/services/manufacturing" exact element={<Home />} />
              <Route path="/components" element={<Components />} />
              <Route path="/careers" element={<Careers />} />
                <Route path="/" element={<Home />} />
            </Routes>
            <Footer />
          </Box>
        </Router>
      </ThemeProvider>
  );
}
